import Storage from "@utils/storage";
import { REMEMBER_ME_EXPIRE_TIME, USER_INFO_KEY } from "@constants/common";
import { UserData } from "@/types/login-type";

export default {
  saveUserInfoToLocal: (data: UserData) => {
    Storage.cache.set(USER_INFO_KEY, data, REMEMBER_ME_EXPIRE_TIME);
  },

  getUserInfoFromLocal: () => {
    return (Storage.cache.get(USER_INFO_KEY) || {}) as UserData;
  },

  clearLocalUserInfo: () => {
    Storage.cache.clearAll();
  },
};
